// web/src/lib/ids.ts
// Shared ID minting — extracted from StudioCreate.tsx so SourceSlot (and other
// Create-screen components) can mint a roastId without duplicating the helper.

/** Mint a roastId, using crypto.randomUUID when available. */
export function mintRoastId(): string {
  return typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
